<script setup lang="ts">
import type { DemoSlot } from '../../model/demo-slot/interfaces'

import { faLink, faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'

import { AppRoute } from '@shared/config'
import { AppIcon, amplitudeIcon as amplitude } from '@shared/ui/icons'
import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useSlotActions } from '../../model/shift-control/slot-actions.hook'

defineOptions({
  name: 'SlotActions',
})

const props = defineProps<{
  tutorSlot: DemoSlot
}>()

const router = useRouter()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  toggle,
  openAction,
} = useSlotActions()

const tutor = computed(() => props.tutorSlot.tutor)

const slotLogHref = computed<string>(() => {
  const slotStart = `${props.tutorSlot.start.slice(0, 16)}:00`
  return router.resolve({
    path: AppRoute.DemosTutorSlotLog,
    query: {
      tutor_id: String(props.tutorSlot.tutor_id),
      slot_start: slotStart,
      page: '1',
    },
  }).href
})
</script>

<template>
  <div
    ref="containerRef"
    class="slot-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="slot-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          v-if="tutor?.discord_url"
          text="To tutor's Discord"
          color="blue"
          @click="openAction(tutor.discord_url)"
        >
          <template #prepend-icon>
            <AppIcon
              color="indigo-600"
              :icon="faDiscord"
            />
          </template>
        </AppDropdownItem>
        <AppDropdownItem
          v-if="tutor?.amplitude_url"
          text="To tutor's Amplitude"
          color="blue"
          @click="openAction(tutor.amplitude_url)"
        >
          <template #prepend-icon>
            <img
              :src="amplitude"
              alt="amplitude icon"
            >
          </template>
        </AppDropdownItem>
        <AppDropdownItem
          v-if="tutor?.app_url"
          text="Act on behalf tutor"
          color="blue"
          :prepend-icon="faLink"
          @click="openAction(tutor.app_url)"
        />
        <AppDropdownItem
          text="View slot changelog"
          color="blue"
          :prepend-icon="faClockRotateLeft"
          @click="openAction(slotLogHref)"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./SlotActions.scss" />
